<template>
  <div class="col-12">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm">
                <thead>
                    <th>
                        النوع
                    </th>
                    <th>
                        التاريخ
                    </th>
                    <th>
                        حذف
                    </th>
                </thead>
                <tbody>
                    <tr v-for="request in requests" :key="request._id">
                        <td>
                            {{ request.command.type }}
                        </td>
                        <td>
                            {{ request.date }}
                        </td>
                        <td>
                            <button class="btn btn-sm btn-danger" @click="deleteRequest(request._id)" style="padding: 3px"><i class="fa fa-trash"></i> حذف</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            requests: [],
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/devices/pending-requests', {
                jwt: g.user.jwt
            }).then(function(r){
                g.requests = r.response
            })
        },
        deleteRequest(id){
            var g = this;
            if(confirm("متأكد من الحذف؟")){
                $.post(api + '/user/devices/pending-requests-delete', {
                    jwt: g.user.jwt,
                    id: id
                }).then(function(r){
                    g.gett()
                })
            }
        },
    }
}
</script>

<style>

</style>